/** ISO3 to region mapping for all countries */
import type { Region } from '../types';

export const countryRegions: Record<string, Region> = {
  // Africa
  DZA: 'Africa', AGO: 'Africa', BEN: 'Africa', BWA: 'Africa', BFA: 'Africa',
  BDI: 'Africa', CPV: 'Africa', CMR: 'Africa', CAF: 'Africa', TCD: 'Africa',
  COM: 'Africa', COG: 'Africa', COD: 'Africa', CIV: 'Africa', DJI: 'Africa',
  EGY: 'Africa', GNQ: 'Africa', ERI: 'Africa', SWZ: 'Africa', ETH: 'Africa',
  GAB: 'Africa', GMB: 'Africa', GHA: 'Africa', GIN: 'Africa', GNB: 'Africa',
  KEN: 'Africa', LSO: 'Africa', LBR: 'Africa', LBY: 'Africa', MDG: 'Africa',
  MWI: 'Africa', MLI: 'Africa', MRT: 'Africa', MUS: 'Africa', MAR: 'Africa',
  MOZ: 'Africa', NAM: 'Africa', NER: 'Africa', NGA: 'Africa', RWA: 'Africa',
  STP: 'Africa', SEN: 'Africa', SYC: 'Africa', SLE: 'Africa', SOM: 'Africa',
  ZAF: 'Africa', SSD: 'Africa', SDN: 'Africa', TZA: 'Africa', TGO: 'Africa',
  TUN: 'Africa', UGA: 'Africa', ZMB: 'Africa', ZWE: 'Africa', ESH: 'Africa',

  // Americas
  ARG: 'Americas', BLZ: 'Americas', BOL: 'Americas', BRA: 'Americas',
  CAN: 'Americas', CHL: 'Americas', COL: 'Americas', CRI: 'Americas',
  CUB: 'Americas', DOM: 'Americas', ECU: 'Americas', SLV: 'Americas',
  GTM: 'Americas', GUY: 'Americas', HTI: 'Americas', HND: 'Americas',
  JAM: 'Americas', MEX: 'Americas', NIC: 'Americas', PAN: 'Americas',
  PRY: 'Americas', PER: 'Americas', SUR: 'Americas', TTO: 'Americas',
  USA: 'Americas', URY: 'Americas', VEN: 'Americas',

  // Asia
  AFG: 'Asia', BGD: 'Asia', BTN: 'Asia', BRN: 'Asia', KHM: 'Asia',
  CHN: 'Asia', IND: 'Asia', IDN: 'Asia', JPN: 'Asia', KAZ: 'Asia',
  KGZ: 'Asia', LAO: 'Asia', MYS: 'Asia', MDV: 'Asia', MNG: 'Asia',
  MMR: 'Asia', NPL: 'Asia', PRK: 'Asia', PAK: 'Asia', PHL: 'Asia',
  SGP: 'Asia', KOR: 'Asia', LKA: 'Asia', TWN: 'Asia', TJK: 'Asia',
  THA: 'Asia', TLS: 'Asia', TKM: 'Asia', UZB: 'Asia', VNM: 'Asia',

  // Europe
  ALB: 'Europe', AND: 'Europe', AUT: 'Europe', BLR: 'Europe', BEL: 'Europe',
  BIH: 'Europe', BGR: 'Europe', HRV: 'Europe', CYP: 'Europe', CZE: 'Europe',
  DNK: 'Europe', EST: 'Europe', FIN: 'Europe', FRA: 'Europe', DEU: 'Europe',
  GRC: 'Europe', HUN: 'Europe', ISL: 'Europe', IRL: 'Europe', ITA: 'Europe',
  XKX: 'Europe', LVA: 'Europe', LTU: 'Europe', LUX: 'Europe', MLT: 'Europe',
  MDA: 'Europe', MNE: 'Europe', NLD: 'Europe', MKD: 'Europe', NOR: 'Europe',
  POL: 'Europe', PRT: 'Europe', ROU: 'Europe', RUS: 'Europe', SRB: 'Europe',
  SVK: 'Europe', SVN: 'Europe', ESP: 'Europe', SWE: 'Europe', CHE: 'Europe',
  UKR: 'Europe', GBR: 'Europe', ARM: 'Europe', AZE: 'Europe', GEO: 'Europe',

  // Middle East
  BHR: 'Middle East', IRN: 'Middle East', IRQ: 'Middle East', ISR: 'Middle East',
  JOR: 'Middle East', KWT: 'Middle East', LBN: 'Middle East', OMN: 'Middle East',
  PSE: 'Middle East', QAT: 'Middle East', SAU: 'Middle East', SYR: 'Middle East',
  TUR: 'Middle East', ARE: 'Middle East', YEM: 'Middle East',

  // Oceania
  AUS: 'Oceania', FJI: 'Oceania', NZL: 'Oceania', PNG: 'Oceania',
  SLB: 'Oceania', VUT: 'Oceania', WSM: 'Oceania',
};

/** Country display names for all ISO3 codes */
export const countryNames: Record<string, string> = {
  AFG: 'Afghanistan', ALB: 'Albania', DZA: 'Algeria', AND: 'Andorra',
  AGO: 'Angola', ARG: 'Argentina', ARM: 'Armenia', AUS: 'Australia',
  AUT: 'Austria', AZE: 'Azerbaijan', BHR: 'Bahrain', BGD: 'Bangladesh',
  BLR: 'Belarus', BEL: 'Belgium', BLZ: 'Belize', BEN: 'Benin',
  BTN: 'Bhutan', BOL: 'Bolivia', BIH: 'Bosnia and Herzegovina',
  BWA: 'Botswana', BRA: 'Brazil', BRN: 'Brunei', BGR: 'Bulgaria',
  BFA: 'Burkina Faso', BDI: 'Burundi', KHM: 'Cambodia', CMR: 'Cameroon',
  CAN: 'Canada', CPV: 'Cape Verde', CAF: 'Central African Republic',
  TCD: 'Chad', CHL: 'Chile', CHN: 'China', COL: 'Colombia',
  COM: 'Comoros', COG: 'Congo', COD: 'DR Congo', CRI: 'Costa Rica',
  CIV: 'Ivory Coast', HRV: 'Croatia', CUB: 'Cuba', CYP: 'Cyprus',
  CZE: 'Czechia', DNK: 'Denmark', DJI: 'Djibouti', DOM: 'Dominican Republic',
  ECU: 'Ecuador', EGY: 'Egypt', SLV: 'El Salvador', GNQ: 'Equatorial Guinea',
  ERI: 'Eritrea', EST: 'Estonia', SWZ: 'Eswatini', ETH: 'Ethiopia',
  FJI: 'Fiji', FIN: 'Finland', FRA: 'France', GAB: 'Gabon',
  GMB: 'Gambia', GEO: 'Georgia', DEU: 'Germany', GHA: 'Ghana',
  GRC: 'Greece', GTM: 'Guatemala', GIN: 'Guinea', GNB: 'Guinea-Bissau',
  GUY: 'Guyana', HTI: 'Haiti', HND: 'Honduras', HUN: 'Hungary',
  ISL: 'Iceland', IND: 'India', IDN: 'Indonesia', IRN: 'Iran',
  IRQ: 'Iraq', IRL: 'Ireland', ISR: 'Israel', ITA: 'Italy',
  JAM: 'Jamaica', JPN: 'Japan', JOR: 'Jordan', KAZ: 'Kazakhstan',
  KEN: 'Kenya', KWT: 'Kuwait', KGZ: 'Kyrgyzstan', LAO: 'Laos',
  LVA: 'Latvia', LBN: 'Lebanon', LSO: 'Lesotho', LBR: 'Liberia',
  LBY: 'Libya', LTU: 'Lithuania', LUX: 'Luxembourg', MDG: 'Madagascar',
  MWI: 'Malawi', MYS: 'Malaysia', MDV: 'Maldives', MLI: 'Mali',
  MLT: 'Malta', MRT: 'Mauritania', MUS: 'Mauritius', MEX: 'Mexico',
  MDA: 'Moldova', MNG: 'Mongolia', MNE: 'Montenegro', MAR: 'Morocco',
  MOZ: 'Mozambique', MMR: 'Myanmar', NAM: 'Namibia', NPL: 'Nepal',
  NLD: 'Netherlands', NZL: 'New Zealand', NIC: 'Nicaragua', NER: 'Niger',
  NGA: 'Nigeria', PRK: 'North Korea', MKD: 'North Macedonia',
  NOR: 'Norway', OMN: 'Oman', PAK: 'Pakistan', PSE: 'Palestine',
  PAN: 'Panama', PNG: 'Papua New Guinea', PRY: 'Paraguay', PER: 'Peru',
  PHL: 'Philippines', POL: 'Poland', PRT: 'Portugal', QAT: 'Qatar',
  ROU: 'Romania', RUS: 'Russia', RWA: 'Rwanda', SAU: 'Saudi Arabia',
  SEN: 'Senegal', SRB: 'Serbia', SYC: 'Seychelles', SLE: 'Sierra Leone',
  SGP: 'Singapore', SVK: 'Slovakia', SVN: 'Slovenia', SLB: 'Solomon Islands',
  SOM: 'Somalia', ZAF: 'South Africa', KOR: 'South Korea',
  SSD: 'South Sudan', ESP: 'Spain', LKA: 'Sri Lanka', SDN: 'Sudan',
  SUR: 'Suriname', SWE: 'Sweden', CHE: 'Switzerland', SYR: 'Syria',
  TWN: 'Taiwan', TJK: 'Tajikistan', TZA: 'Tanzania', THA: 'Thailand',
  TLS: 'Timor-Leste', TGO: 'Togo', TTO: 'Trinidad and Tobago',
  TUN: 'Tunisia', TUR: 'Turkey', TKM: 'Turkmenistan', UGA: 'Uganda',
  UKR: 'Ukraine', ARE: 'UAE', GBR: 'United Kingdom',
  USA: 'United States', URY: 'Uruguay', UZB: 'Uzbekistan',
  VUT: 'Vanuatu', VEN: 'Venezuela', VNM: 'Vietnam', ESH: 'Western Sahara',
  YEM: 'Yemen', ZMB: 'Zambia', ZWE: 'Zimbabwe', WSM: 'Samoa',
  STP: 'São Tomé and Príncipe', XKX: 'Kosovo',
};
